import React from 'react';
import { Button } from '@material-ui/core';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Koordinat from '../../components/GeoLocation';


const useStyles = makeStyles((theme) => ({
  root: {},
  review: {
    marginTop: theme.spacing(2)
  },
  submitButtonKoordinat: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function Lokasyon({ className, ...rest }) {
  const classes = useStyles();
  const handleKoordinatAppOpen = () => {
    localStorage.removeItem('ArtemisApp');
    sessionStorage.removeItem('ArtemisApp');
    localStorage.setItem('ArtemisApp', 1);
    sessionStorage.setItem('ArtemisApp', 1);
    // var AppLink = "artemis://lokasyon.com?control=1&technicianId=" + KoordinatTeknisyenKodu.toString();
    // try {
    //   event.persist();
    //   window.open(AppLink, '_self');
    //   event.persist();
    // } catch (error) {
     
    // }
  }


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Button
        variant="contained"
        color="secondary"
        className={classes.submitButtonKoordinat}
        onClick={(event) => handleKoordinatAppOpen(event)}
        endIcon={<AddLocationIcon>Koordinat</AddLocationIcon>}>
        Koordİnat Uygulamasını Aç
      </Button>
      <br />
      <br />
      <Koordinat></Koordinat>
    </div>
  );
}

Lokasyon.propTypes = {
  className: PropTypes.string
};

export default Lokasyon;
